import React from "react";
import PageNavbar from "@insightfulscience/atomic-react/PageNavbar";
import PageNavbarItem from "@insightfulscience/atomic-react/PageNavbar/Item";
import Dropdown from "@insightfulscience/atomic-react/Dropdown";
import DropdownMenu from "@insightfulscience/atomic-react/Dropdown/Menu";
import DropdownMenuItem from "@insightfulscience/atomic-react/Dropdown/MenuItem";
import { arrayOf, number, shape, string } from "prop-types";
import getContentProps from "@insightfulscience/contentful/utils/getContentProps";

const HeroIconSection = ({ items = [] }) => {
	return (
		items.length > 0 && (
			<PageNavbar
				sticky
				bgColor="white"
				utility={{ sm: { display: "none" }, md: { display: "none" } }}
			>
				{items.map((item) => (
					<PageNavbarItem key={item.id}>
						<Dropdown
							utility={{ display: "block" }}
							sx={{ textAlign: "center" }}
						>
							<Dropdown.Title
								triangleProps={{ color: "3", isOpenColor: "3" }}
								sx={{ textAlign: "center", fontWeight: "bold", fontSize: "m" }}
								utility={{ display: "flex", justify: "center" }}
								spacing={{ py: 2 }}
								className="navbar-item-b-line"
							>
								{item.name}
							</Dropdown.Title>
							<Dropdown.Body align="full">
								<DropdownMenu>
									<DropdownMenuItem key={item.id}>
										<DropdownMenuItem.Link href={`#${item.id}`}>
											View All
										</DropdownMenuItem.Link>
									</DropdownMenuItem>

									{(item.contentReference || []).map((subItem) => {
										const { slug = "", externalUrl = "" } = subItem.fields;
										const contentProps = getContentProps(
											subItem?.sys?.contentType?.sys?.id,
										);

										return (
											<DropdownMenuItem key={subItem.sys.sys_id}>
												<DropdownMenuItem.Link
													href={
														contentProps && contentProps.alias
															? `${contentProps.alias}/${slug}`
															: externalUrl
													}
												>
													{subItem.fields.title}
												</DropdownMenuItem.Link>
											</DropdownMenuItem>
										);
									})}
								</DropdownMenu>
							</Dropdown.Body>
						</Dropdown>
					</PageNavbarItem>
				))}
			</PageNavbar>
		)
	);
};

HeroIconSection.propTypes = {
	items: arrayOf(
		shape({
			blockOrder: number,
			id: string,
			name: string,
			items: arrayOf(
				shape({
					title: string,
					url: string,
					externalUrl: string,
					slug: string,
					type: string,
					sys_id: string,
				}),
			),
		}),
	),
};

export default HeroIconSection;
